const addOrder = (state, order) => {
  state.orders.push(order)
};

const setListOrder = (state, listOrder) => {
  state.orders=listOrder
};



export default {
  addOrder,
  setListOrder,
};





// WEBPACK FOOTER //
// ./src/store/modules/orders/mutations.js